import styled from 'styled-components';

export const StyledMachineDetailsPanelGcd = styled.div`
  min-height: inherit;
`;
